var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPinterest14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.212 2.5C4.744 2.5 3.5 4.26 3.5 5.73c0 .889.338 1.68 1.064 1.974.119.049.225.002.26-.13.024-.09.08-.319.106-.414.034-.13.02-.175-.075-.288-.21-.246-.343-.564-.343-1.014 0-1.306.982-2.476 2.557-2.476 1.395 0 2.161.848 2.161 1.981 0 1.49-.662 2.749-1.646 2.749-.544 0-.95-.447-.82-.996.156-.655.459-1.362.459-1.834 0-.423-.229-.776-.7-.776-.556 0-1.003.571-1.003 1.338 0 .488.166.818.166.818l-.668 2.817c-.198.836-.03 1.86-.016 1.964.009.061.088.076.124.03.051-.067.713-.88.938-1.692.063-.23.365-1.42.365-1.42.18.342.708.643 1.269.643 1.67 0 2.802-1.515 2.802-3.543C10.5 3.928 9.195 2.5 7.212 2.5"
}))));
export default SvgChannelPinterest14;